import { Children, cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { close, open } from '../actions';
import { isOpened } from '../selectors';
import { isSalesForceChatOpen } from '../utils';

const SIZE = '60px';
const WrapperElement = styled.div`
    position: absolute;
    bottom: 20px;
    right: 20px;
`;

const AddButtonElement = styled.div`
    border-radius: 50%;
    height: ${SIZE};
    width: ${SIZE};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow:
        0 1px 6px 0 rgba(0, 0, 0, 0.06),
        0 2px 32px 0 rgba(0, 0, 0, 0.16);
    background: #707070;
    cursor: pointer;
`;

interface Props {
    open?: $TSFixMeFunction;
    close?: $TSFixMeFunction;
    opened?: boolean;
}

class ChatButton extends Component<React.PropsWithChildren<Props>> {
    componentWillUnmount() {
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.close();
    }

    handleClick = () => {
        if (isSalesForceChatOpen()) {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            this.props.close();
        } else {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            this.props.open();
        }
    };

    render() {
        const { opened, children } = this.props;
        return (
            <WrapperElement>
                <AddButtonElement onClick={this.handleClick}>
                    {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                    {Children.map(children, (child) => cloneElement(child, { opened }))}
                </AddButtonElement>
            </WrapperElement>
        );
    }
}

export default connect(
    createStructuredSelector({
        opened: isOpened,
    }),
    {
        open,
        close,
    }
)(ChatButton);
